import { useContext } from 'react';
import { ModalContext } from '../context/modal-context';
/**
 * useModal hook
 *
 * @example
 *     export { useModal } from 'hooks/use-modal;
 *
 *     const BasicModalContent = ({title}: string) => <p>This is a basic modal's content. {title}</p>;
 *
 *     const TestComponent = () => {
 *        const { hideModal, openModal } = useModal();
 *
 *        // Update  stencil modal props
 *        const modalProps = { size: 'sm' };
 *
 *        const openBasicModal = () => {
 *          openModal(BasicModalContent, { title: 'Modal Title' }, modalProps);
 *        }
 *
 *        return (
 *          <div>
 *            <button onClick={openBasicModal}>Open modal</button>
 *            <button onClick={hideModal}>Close modal</button>
 *          </div>
 *        )
 *  }
 *
 */
export var useModal = function () {
    var context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};
